export enum ELanguageCodes {
  Pl = 'pl-PL',
  En = 'en-US'
}

export const EShortLanguageCodes = {
  EN: 'en',
  PL: 'pl'
} as const;

export const appDefaultLanguageCode = ELanguageCodes.En;

export enum ELanguageDisplayNames {
  Polski = 'PL',
  English = 'EN'
}

export interface ILanguage {
  code: string;
  displayName: ELanguageDisplayNames;
}

export const supportedLanguages: ILanguage[] = [
  { code: ELanguageCodes.Pl, displayName: ELanguageDisplayNames.Polski } as ILanguage,
  { code: ELanguageCodes.En, displayName: ELanguageDisplayNames.English } as ILanguage
];

export const getSupportedLanguageCodes = (): string[] =>
  supportedLanguages.map(language => language.code);

export const normalizeLanguageCode = (languageCode?: string | null): string => {
  if (!languageCode || languageCode.trim() === '') {
    return appDefaultLanguageCode;
  }

  const trimmedLanguageCode = languageCode.trim().toLowerCase();

  if (trimmedLanguageCode === ELanguageCodes.En.toLowerCase()) {
    return ELanguageCodes.En;
  }

  if (trimmedLanguageCode === ELanguageCodes.Pl.toLowerCase()) {
    return ELanguageCodes.Pl;
  }

  if (trimmedLanguageCode === EShortLanguageCodes.EN || trimmedLanguageCode.startsWith('en')) {
    return ELanguageCodes.En;
  }

  if (trimmedLanguageCode === EShortLanguageCodes.PL || trimmedLanguageCode.startsWith('pl')) {
    return ELanguageCodes.Pl;
  }

  const supportedLanguageCodes = getSupportedLanguageCodes();
  const foundLanguageCode = supportedLanguageCodes.find(
    code => code.toLowerCase() === trimmedLanguageCode
  );

  if (foundLanguageCode) {
    return foundLanguageCode;
  }

  return appDefaultLanguageCode;
};
